import { Component, ViewEncapsulation, Input } from '@angular/core';
import { AuthService } from '@core/authentication/auth.service';

@Component({
  selector: 'error-code',
  templateUrl: './error-code.component.html',
  styleUrls: ['./error-code.component.scss'],
  encapsulation: ViewEncapsulation.None,
})
export class ErrorCodeComponent {
  @Input() code = '';

  @Input() message = '';

  @Input() showHomeButton = true;

  @Input() showLogoutButton = false;

  @Input() title = '';

  constructor(private authService: AuthService) {}

  public logout(): void {
    this.authService.logout();
  }
}
